import React from "react";
import { motion } from "framer-motion";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { FiMail } from "react-icons/fi";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="premium-footer">
      <div className="footer-inner">
        {/* Logo */}
        <motion.div
          className="footer-logo"
          whileHover={{ scale: 1.05 }}
        >
          <span className="footer-bracket">&lt;</span>
          <span className="footer-name">ShabinSV</span>
          <span className="footer-bracket">/&gt;</span>
        </motion.div>

        {/* Tagline */}
        <p className="footer-tagline">
          Building the future, one line at a time.
        </p>

        {/* Social links */}
        <div className="footer-socials">
          <motion.a
            href="https://in.linkedin.com/in/shabin-sv-831872228"
            target="_blank"
            rel="noreferrer"
            className="footer-social"
            whileHover={{ scale: 1.15, y: -3 }}
            whileTap={{ scale: 0.95 }}
            title="LinkedIn"
          >
            <FaLinkedin />
          </motion.a>
          <motion.a
            href="https://github.com/shabinsv"
            target="_blank"
            rel="noreferrer"
            className="footer-social"
            whileHover={{ scale: 1.15, y: -3 }}
            whileTap={{ scale: 0.95 }}
            title="GitHub"
          >
            <FaGithub />
          </motion.a>
          <motion.a
            href="mailto:shabinsv7@gmail.com"
            className="footer-social"
            whileHover={{ scale: 1.15, y: -3 }}
            whileTap={{ scale: 0.95 }}
            title="Email"
          >
            <FiMail />
          </motion.a>
        </div>

        {/* Divider */}
        <div className="footer-divider" />

        {/* Copyright */}
        <p className="footer-copy">
          &copy; {currentYear} <strong>shabinsv.in</strong>
        </p>
      </div>

      <style>{`
        .premium-footer {
          background: rgba(7, 7, 20, 0.95);
          backdrop-filter: blur(20px);
          border-top: 1px solid rgba(99, 102, 241, 0.12);
          padding: 3rem 2rem 2rem;
          text-align: center;
        }

        .footer-inner {
          max-width: 600px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1rem;
        }

        .footer-logo {
          font-family: 'Fira Code', monospace;
          font-size: 1.3rem;
          font-weight: 700;
          cursor: default;
        }

        .footer-bracket {
          color: #6366f1;
          text-shadow: 0 0 10px rgba(99,102,241,0.6);
        }

        .footer-name {
          background: linear-gradient(135deg, #e2e8f0, #a78bfa);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin: 0 3px;
        }

        .footer-tagline {
          font-family: 'Poppins', sans-serif;
          font-size: 0.85rem;
          color: rgba(226,232,240,0.4);
          letter-spacing: 0.05em;
          margin: 0;
        }

        .footer-socials {
          display: flex;
          gap: 12px;
          margin-top: 4px;
        }

        .footer-social {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 38px;
          height: 38px;
          border-radius: 10px;
          background: rgba(255,255,255,0.05);
          border: 1px solid rgba(255,255,255,0.08);
          color: rgba(226,232,240,0.6);
          font-size: 1.05rem;
          text-decoration: none;
          transition: all 0.25s ease;
        }

        .footer-social:hover {
          background: rgba(99,102,241,0.2);
          border-color: rgba(99,102,241,0.35);
          color: #a78bfa;
        }

        .footer-divider {
          width: 80px;
          height: 1px;
          background: linear-gradient(90deg, transparent, rgba(99,102,241,0.4), transparent);
          margin: 4px 0;
        }

        .footer-copy {
          font-family: 'Fira Code', monospace;
          font-size: 0.78rem;
          color: rgba(226,232,240,0.3);
          letter-spacing: 0.05em;
          margin: 0;
          line-height: 1.8;
        }

        .footer-copy strong {
          background: linear-gradient(135deg, #6366f1, #a78bfa);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
      `}</style>
    </footer>
  );
}

export default Footer;
